module.exports = __webpack_public_path__ + "assets/x.33207641.svg";